import src from "IMAGE";
export default { src, width: 445, height: 102, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAPUlEQVR42i3KoQ3AIAAFUdbrCKzQtIBAEAyKpdgKhSDwOYF4yYkz6i1rzyDJIyLjx4PXaA1LVBQkfHB3sgcGkTZLTyXcMwAAAABJRU5ErkJggg=="};
